.articleFooterWrapper {
  border-top: 1px solid #f2f2f2;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 16px 0;
}
.articleFooterWrapper a {
  display: inline-block;
}
